import { render, staticRenderFns } from "./fees-loader.vue?vue&type=template&id=6a139ba2"
import script from "./fees-loader.vue?vue&type=script&lang=js"
export * from "./fees-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports